import { useCollectionContext as a } from "./VDHZ5F7K.js";
import { createHook as p, forwardRef as I, createElement as R } from "./LMDWO4NN.js";
import { useId as _, useMergeRefs as g } from "./ABQUS43J.js";
import { __objRest as v, __spreadProps as C, __spreadValues as h } from "./3YLGPPWQ.js";
import { identity as x, removeUndefinedValues as b } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/PBFD2E7P.js";
import { useRef as w, useEffect as E } from "react";
var P = "div", V = p(
  function(o) {
    var r = o, {
      store: e,
      shouldRegisterItem: m = !0,
      getItem: s = x,
      element: l
    } = r, t = v(r, [
      "store",
      "shouldRegisterItem",
      "getItem",
      // @ts-expect-error This prop may come from a collection renderer.
      "element"
    ]);
    const c = a();
    e = e || c;
    const n = _(t.id), i = w(l);
    return E(() => {
      const f = i.current;
      if (!n || !f || !m) return;
      const d = s({ id: n, element: f });
      return e == null ? void 0 : e.renderItem(d);
    }, [n, m, s, e]), t = C(h({}, t), {
      ref: g(i, t.ref)
    }), b(t);
  }
);
I(function(o) {
  const r = V(o);
  return R(P, r);
});
export {
  V as useCollectionItem
};
//# sourceMappingURL=RZ4GPYOB.js.map
